// videos.js (or keep in same file if you prefer)
import VideoBox1 from "assets/home-box-1.png";
import VideoBox2 from "assets/home-box-2.png";
import VideoBox3 from "assets/home-box-3.png";
import VideoBox4 from "assets/home-box-4.png";
import VideoBox5 from "assets/home-box-5.png";
import VideoBox6 from "assets/home-box-6.png";
import VideoBox7 from "assets/home-box-7.png";
import VideoBox8 from "assets/home-box-8.png";

export const videos = [
  {
    id: 1,
    thumbnail: VideoBox1,
    title: "Video Name",
    url: "https://www.youtube.com/embed/s0zeuUxmTxI?si=QtZborlJ6jmwfbQn",
  },
  {
    id: 2,
    thumbnail: VideoBox2,
    title: "Video Name",
    url: "https://www.youtube.com/embed/wqhvVRPpels?si=qUqDU_t69-VU0Vy7",
  },
  {
    id: 3,
    thumbnail: VideoBox3,
    title: "Video Name",
    url: "https://www.youtube.com/embed/gSjoX1c-ZWY?si=ZmjwkLgn3huDsRxw",
  },
  {
    id: 4,
    thumbnail: VideoBox4,
    title: "Video Name",
    url: "https://www.youtube.com/embed/7mEcEtu0Y_0?si=pbfLoi9zLKaydtjh",
  },
  {
    id: 5,
    thumbnail: VideoBox5,
    title: "Video Name",
    url: "https://www.youtube.com/embed/dYyobv1tcek?si=UaCbGzS5SGYVojOb",
  },
  {
    id: 6,
    thumbnail: VideoBox6,
    title: "Video Name",
    url: "https://www.youtube.com/embed/0ZgizY-9jOc?si=ojSaMsQKGmNpjLkX",
  },
  {
    id: 7,
    thumbnail: VideoBox7,
    title: "Video Name",
    url: "https://www.youtube.com/embed/gwNJyhAWXD8?si=D2xuqVGkM7t1L4OW",
  },
  {
    id: 8,
    thumbnail: VideoBox8,
    title: "Video Name",
    url: "https://www.youtube.com/embed/5Wcfa5GXJtI?si=uzDO3DGlTKeWWwtl",
  },
];
